module.exports = __webpack_public_path__ + "d2047b515c90b000d7068b1636c4fafb.png";